export const SPAREPART_PAGE_LIMIT = 20
export const SPAREPART_SORT = { sort_by: 'id', order_by: 'asc' }
export const SEARCH_DEBOUNCE_MS = 300
export const SPAREPART_MODAL_WIDTH = 400
